var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14H4.4C3.55992 14 3.13988 14 2.81901 13.8365C2.53677 13.6927 2.3073 13.4632 2.16349 13.181C2 12.8601 2 12.4401 2 11.6V4.4C2 3.55992 2 3.13988 2.16349 2.81901C2.3073 2.53677 2.53677 2.3073 2.81901 2.16349C3.13988 2 3.55992 2 4.4 2H11.6C12.4401 2 12.8601 2 13.181 2.16349C13.4632 2.3073 13.6927 2.53677 13.8365 2.81901C14 3.13988 14 3.55992 14 4.4V8.5M5 5H8V8H5V5ZM11 11H14V11.6C14 12.4401 14 12.8601 13.8365 13.181C13.6927 13.4632 13.4632 13.6927 13.181 13.8365C12.8601 14 12.4401 14 11.6 14H11V11Z",
    stroke: "#6C7689",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#6C76891F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.63aa427a52a68595812642fdf04c2d10.svg";
export { ForwardRef as ReactComponent };